<!-- 
<div class="wrapper mt-md-5 pt-md-5">
 <div class="container">
  <div class="row">
    <div class="col-4" *ngFor="let item of items">
      <div class="text-center buy-with-para">
        <svg-icon [src]="item.img" [svgStyle]="{ 'height.px':62}"></svg-icon>
        <p class="p-0 m-0 p-3 fw-medium text-light font-20 d-none d-lg-block"  >
        
          {{item.head |  translate}}
        </p>
        <p class="p-0 m-0 p-3 fw-medium text-light font-20 mob-para d-block d-lg-none" >
        
          {{item.head_mob |  translate}}
        </p>
      </div>
     </div>
    </div>
  </div>
</div> -->

<!-- NON-CUSTODIAL WALLET -->
<section appScrollAnimation>
  <div id="buy-with">
    <div class="container">
      <div class="store-wallet-wrapper">
        <div class="store-left-part">
          <h2 class="labels font-16">{{"non-custodial" | translate}}</h2>
          <h2 class="heading">
            {{"store"| translate}}<br>
            {{"multi-wallet" | translate}}<br>
            {{"multi-chain" | translate}}
          </h2>
          <div class="custodial">
            <p class="para1">
              {{"custodial-para" | translate}}
            </p>
          </div>

        </div>
        <div class="store-img">
          <img src="assets/images/store-digital.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</section>